// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from "react";

const SvgPaginationPrev24 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			d="M14.521 6.807 6.61 11.122a1 1 0 0 0 0 1.756l7.912 4.315A1 1 0 0 0 16 16.315v-8.63a1 1 0 0 0-1.479-.878Z"
		/>
	</svg>
);
export default SvgPaginationPrev24;
